import { createTheme } from '@mui/material'
import { COLORS } from '../constants/colors'

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: COLORS.gold.primary },
    secondary: { main: COLORS.blue.primary },
    success: { main: COLORS.green.primary },
    error: { main: COLORS.red.primary },
    warning: { main: COLORS.gold.dark },
    background: {
      default: COLORS.bg.primary,
      paper: COLORS.bg.card,
    },
    text: {
      primary: COLORS.text.primary,
      secondary: COLORS.text.secondary,
    },
  },
  typography: {
    fontFamily: "'Montserrat', -apple-system, BlinkMacSystemFont, sans-serif",
    h1: { fontWeight: 900, letterSpacing: '-1px' },
    h2: { fontWeight: 800, letterSpacing: '-0.5px' },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 500, letterSpacing: '0.5px' },
    subtitle2: { fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase', fontSize: '0.75rem' },
    body2: { color: COLORS.text.secondary },
    caption: { color: COLORS.text.muted, fontFamily: "'JetBrains Mono', monospace" },
    overline: { letterSpacing: '2px', fontWeight: 700 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: COLORS.bg.primary,
          backgroundImage: COLORS.bg.gradient,
          backgroundAttachment: 'fixed',
        },
        '::-webkit-scrollbar': { width: '6px' },
        '::-webkit-scrollbar-track': { background: COLORS.bg.primary },
        '::-webkit-scrollbar-thumb': {
          background: `linear-gradient(45deg, ${COLORS.gold.primary}, ${COLORS.blue.primary})`,
          borderRadius: '3px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: COLORS.bg.card,
          border: `1px solid ${COLORS.border.subtle}`,
        },
      },
    },
  },
})
